import React, { useContext } from "react";
import Select from "../../Components/Select";
import TenantContext from "../../OnlineFormContext";
import AARCodes from "./AARCodes";

function Subsystem({ selected, system, onChange, equipmentType, equipmentTypeId, hasError }) {
  const contextValues = useContext(TenantContext);
  const aarCodes = new AARCodes(contextValues.tenantAuthToken, equipmentType, equipmentTypeId);

  return (
    <div className="ui fluid input bs-field">
      <Select
        value={selected}
        asynchronous={true}
        paginate={true}
        loadOptions={async (search, _, { page }) => ({
          ...(await aarCodes.subsystemOptions(system, search, page)),
          additional: {
            page: page + 1,
          },
        })}
        onChange={({ label, value, system }) => {
          onChange({
            option: { label, value },
            system,
          });
        }}
        additional={{
          page: 1,
        }}
        cacheUniq={[selected]}
        placeholder={"Subsystem"}
      />
    </div>
  );
}

export default Subsystem;
